"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    StatusBanner: ()=>StatusBanner
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_StatusBanner_variants_cjs_namespaceObject = require("./StatusBanner.variants.cjs");
const icons = {
    info: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
        iconName: "info"
    }),
    success: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
        iconName: "check_circle"
    }),
    caution: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
        iconName: "warning"
    }),
    error: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
        iconName: "error"
    })
};
function StatusBanner({ captionNode, headingNode, primaryCtaNode, secondaryCtaNode, iconNode, hideIcon = false, slots = {
    baseSlot: '',
    contentCtaSlot: '',
    iconSlot: '',
    headingSlot: '',
    captionSlot: '',
    ctaSlot: '',
    headingContentSlot: '',
    iconContentWrapper: ''
}, ...props }) {
    const { baseSlot, headingSlot, captionSlot, ctaSlot, contentCtaSlot, iconSlot, headingContentSlot, iconContentWrapper } = (0, external_StatusBanner_variants_cjs_namespaceObject.statusBannerVariants)({
        ...props
    });
    const icon = hideIcon ? null : iconNode || icons[props.palette];
    const baseSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(baseSlot(), '@container', slots.baseSlot);
    const contentCtaSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(contentCtaSlot(), slots.contentCtaSlot);
    const iconSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(iconSlot(), slots.iconSlot);
    const headingSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(headingSlot(), slots.headingSlot);
    const captionSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(captionSlot(), slots.captionSlot);
    const ctaSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(ctaSlot(), slots.ctaSlot);
    const headingContentSlotClasses = (0, external_utils_index_cjs_namespaceObject.cn)(headingContentSlot(), slots.headingContentSlot);
    const iconContentWrapperClasses = (0, external_utils_index_cjs_namespaceObject.cn)(iconContentWrapper(), slots.iconContentWrapper);
    const getCtaProps = ()=>({
            type: 'tertiary',
            emphasis: 'bold' === props.emphasis ? 'bold' : 'regular',
            className: 'bold' === props.emphasis && 'caution' === props.palette ? 'text-caution-13 hover:text-caution-13' : ''
        });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
        className: baseSlotClasses,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: contentCtaSlotClasses,
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: iconContentWrapperClasses,
                    children: [
                        icon && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: iconSlotClasses,
                            children: icon
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                            className: headingContentSlotClasses,
                            children: [
                                headingNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                    className: headingSlotClasses,
                                    bold: true,
                                    children: headingNode
                                }),
                                captionNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                    className: captionSlotClasses,
                                    children: captionNode
                                })
                            ]
                        })
                    ]
                }),
                (!!primaryCtaNode || !!secondaryCtaNode) && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: ctaSlotClasses,
                    children: [
                        secondaryCtaNode && /*#__PURE__*/ external_react_default().cloneElement(secondaryCtaNode, getCtaProps()),
                        primaryCtaNode && /*#__PURE__*/ external_react_default().cloneElement(primaryCtaNode, getCtaProps())
                    ]
                })
            ]
        })
    });
}
exports.StatusBanner = __webpack_exports__.StatusBanner;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "StatusBanner"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
